module.exports = "<div>\n  <my-table my-data=\"myRailway\"\n    my-nature=\"'railway'\"\n    enable-badges=\"true\">\n  </my-table>\n\n  <my-loading-bar ng-if=\"enableProgression\"\n    my-total=\"myRailway.length\"\n    my-available=\"myRailway.availableLength\">\n  </my-loading-bar>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/entities/rails/railway/directives/display/myRailway.html
// module id = 941
// module chunks = 0